<template>
  <div
    class="v-sidebar-menu h-100"
    :class="['vsm-default', theme]"
  >
    <vue-perfect-scrollbar class="scroll-area">
      <div class="vsm-list mt-3">
        <template v-for="(item, index) in menu">
          <template v-if="item.header">
            <template v-if="item.component">
              <component
                :is="item.component"
                :key="index"
              />
            </template>
            <template v-else>
              <div
                :key="index"
                class="vsm-header"
                v-bind="item.attributes"
              >
                {{ item.title }}
              </div>
            </template>
          </template>
          <item
            v-else
            :key="index"
            :item="item"
            :first-item="true"
            :enable-collapsing="enableCollapsing"
          />
        </template>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Item from './Item.vue';
import SubItem from './SubItem.vue';
import { animationMixin } from '../mixin';

export default {
  name: 'SidebarMenu',
  mixins: [animationMixin],
  props: {
    menu: {
      type: Array,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '300px',
    },
    widthCollapsed: {
      type: String,
      default: '50px',
    },
    enableCollapsing: {
      type: Boolean,
      default: true,
    },
    showChild: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
    showOneChild: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onItemClick(event, item) {
      this.$emit('itemClick', event, item);
    },
  },
  provide() {
    const activeShow = {};
    Object.defineProperty(activeShow, 'uid', {
      enumerable: true,
      get: () => this.activeShow,
    });
    return {
      showChild: this.showChild,
      showOneChild: this.showOneChild,
      enableCollapsing: this.enableCollapsing,
      emitActiveShow: this.onActiveShow,
      activeShow,
      emitItemClick: this.onItemClick,
    };
  },
  components: {
    Item,
    SubItem,
    VuePerfectScrollbar,
  },
};
</script>

<style lang="scss">
.ps__rail-y { z-index:999999; }

.scroll-area {
  position: relative;
  margin: auto;
  height: 100%;
}
</style>
